<template>
  <div>
    <el-table
      :data="condition"
      style="width: 80%">
      <el-table-column
        prop="field_id"
        label="选择判断字段">
        <template scope="scope">
          <el-select v-model="scope.row.field_id" placeholder="请选择" filterable>
            <el-option v-for="item in inputList" 
              :label="item.default.name + '(' + item.default.title + ')'" 
              :value="item.default.field_id">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        prop="type"
        label="判断类型">
        <template scope="scope">
          <el-select v-model="scope.row.type" placeholder="请选择" filterable @change="typeChange(scope.row)">
            <el-option
              v-for="item in typeOptions"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        prop="logic"
        label="逻辑">
        <template scope="scope">
          <el-select v-model="scope.row.logic" placeholder="请选择" filterable v-if="scope.row.type == 10">
            <el-option
              v-for="item in logicTypes"
              :key="item.type"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <span v-else>等于</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="value"
        label="值"
        width="180">
        <template scope="scope">
          <el-input placeholder="指标名称" v-model.trim="scope.row.value" v-if="scope.row.type == 10"></el-input>
          <span v-else>登录ID</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="80">
        <template scope="scope">
          <el-button size="mini" @click.native.prevent="deleteRow(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="m-t-10 tx-c inline-block" style="width:80%">
      <el-button type="primary" @click="addRow">添加一个</el-button>
    </div>
  </div>
</template>

<script>
  /**
   * 操作可用条件配置列表
   * @author duoremix
   * @param Array condition 可用条件
   * @param Array inputList 可选控件
   */
  export default {
    props: {
      condition: {
        type: Array,
        default() {
          return []
        }
      },
      inputList: {
        type: Array,
        default() {
          return []
        }
      }
    },
    name: 'conditionTable',
    data() {
      return {
        conditionModel: {
          field_id: '',
          logic: '',
          type: 10,
          value: ''
        },
        logicTypes: [
          { id: 10, name: '等于' },
          { id: 20, name: '不等于' },
          { id: 30, name: '大于' },
          { id: 40, name: '大于等于' },
          { id: 50, name: '小于' },
          { id: 60, name: '小于等于' },
          { id: 70, name: '含有' }
        ],
        typeOptions: [
          { id: 10, name: '常量' },
          { id: 20, name: '用户ID' }
        ]
      }
    },
    methods: {
      addRow() {
        this.condition.push(_.cloneDeep(this.conditionModel))
      },
      deleteRow(index) {
        this.condition.splice(index, 1)
      },
      typeChange(item) {
        if (item.type == 20) { // 用户ID
          item.logic = 10
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// conditionTable.vue?83ee5736